<template>
  <div id="navse" class="navbar-wrapper" data-aos="fade-in" data-aos-once="true" :class="[ $route.name !== 'landing' ? 'not-landing' : '' ]">
    <!-- <div-container> -->
    <div class="div-container container">
      <div class="columns is-gapless is-centered is-vcentered">
        <div class="column is-12">
          <div class="columns navbar-full is-gapless is-mobile">
            <div class="column navbar-brand is-narrow" align="left">
              <a href="/">
                <!-- <img src="../assets/logo.svg" width="160" class="img-responsive"
                  :style="{ maxWidth: 'auto', padding: '10px', paddingBottom: '0' }" /> -->
                <img src="../assets/logo-main.svg" width="360" class="img-responsive" />
              </a>
            </div>
            <div class="column column-link is-hidden-touch">
              <div class="columns is-gapless" style="margin-top:0;margin-bottom:0;">
                <div class="column has-text-right">
                  <a v-for="navItem in navSocial" class="fa" :href="navItem.path" target="_blank">
                    <i class="fa" :class="['fa-' + navItem.fa]"></i>
                  </a>
                </div>
              </div>
              <div class="columns is-gapless" style="margin-top:0;margin-bottom:0;">
                <div class="column has-text-right">
                  <a v-for="navItem in navMain" :href="[navItem.section ? '/?anchor=' + navItem.section : navItem.path]" @click="[ navItem.section ? onScrollTo($event, 'landing', navItem.section) : '']" :class="{ 'nav-item-link': true, active : $route.name === navItem.name }">
                    {{ navItem.title }}
                  </a>
                </div>
              </div>
              <div class="columns is-gapless" style="margin-top:0;margin-bottom:0;"><!-- // ticket cancelled -->
                <div class="column has-text-right link-ticket-wrapper">
                    <div class="bg">
                      <img src="../assets/bg_ribbon.svg" width=200 />
                    </div>
                    <div class="text">
                      <a href="/tickets">
                        Purchase Tickets
                      </a>
                    </div>
                </div>
              </div>
            </div>
            <div class="column navbar-menu" @click="onToggle()" data-aos="zoom-in" data-aos-once="true">
              <div class="control-menu" :class="{ active : showNav }">
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div-container> -->
  </div>
</template>

<script>
import EventBus from '@/controllers/EventBus'
import DivContainer from '@/components/DivContainer'
export default {
  name: 'navbarfull',
  components: {
    DivContainer
  },
  props: ['toggle'],
  data () {
    return {
      showNav: false,
      navMain: EventBus._data._navMain,
      navSocial: EventBus._data._navSocial,
      navEmail: EventBus._data._navEmail
    }
  },
  computed: {
  },
  watch: {
    toggle: function (val) {
      this.showNav = val
    },
    '$route.name': function (val) {
      // only do this when overlay mode and route change
      if (this.showNav) {
        this.onToggle()
      }
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    onScrollTo ($event, name, target) {
      $event.preventDefault()
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target, { offset: -30 })
      }
    },
    onToggle: function () {
      this.showNav = !this.showNav
      var className = 'modal-open'
      var root = document.documentElement
      root.className = ''
      if (this.showNav) {
        root.className += className
      } else {
        root.className -= className
      }
      this.$emit('onToggle', this.showNav)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/app_setting.scss";

html.modal-open {
  .navbar-wrapper {
    background-color: transparent;
  }
}

.navbar-wrapper {
  background-color: transparent;
  // &.not-landing {
  //   background-color: $color-primary-blue;
  // }
}

#navse {
  z-index: 20;
  // pointer-events: none;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  @media screen and (min-width: $desktop) {
  	// pointer-events: auto;
  }
}

.navbar-full {
  height: 160px;
  align-items: center;
  text-align: center;

  // this to workaround top bar positioning
  // position: absolute;
  // top: 0;
  // right: 0;
  // width: 40%;
  // this to workaround top bar positioning

  // background-color:rgba(0,0,0,0.5);
  @media screen and (min-width: $tablet) {
  }

  // pointer-events: none;
  @media screen and (min-width: $desktop) {
    height: 160px;
  	// pointer-events: auto;
  }

  .column {
    padding: 0.25rem;

    a {
      font-family: $font-family-title;
      font-weight: bold;
      color: $color-white;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      font-size: 0.9rem;
      padding: 4px 8px;

      &:hover, div:hover, &.active {
        color: $color-gray-light;
      }

      &.active {
        // border-bottom: 1px solid $color-gray-light;
      }

      @media screen and (min-width: $desktop) {
        padding: 4px 8px;
      }

      @media screen and (min-width: $fullhd) {
        padding: 4px 10px;
      }

      &.fa {
        color: $color-orange;
        font-size: 1.4rem;
        padding: 8px 12px;

        &:last-child {
          padding-right: 20px;
        }

        &:hover {
          color: $color-gray-mid;
        }
      }
    }

    &.navbar-brand,
    &.navbar-menu {
      padding: 0px;
      margin: 0px;
    }

    &.navbar-menu {
      @media screen and (min-width: $desktop) {
        margin-left: 20px;
      }
    }

    &.navbar-brand {
      img {
        margin-top: 20px;
        width: 260px;

        @media screen and (min-width: $tablet) {
          width: 300px;
        }

        @media screen and (min-width: $desktop) {
          width: 340px;
        }
      }
    }

    .link-ticket-wrapper {
      position: relative;

      .bg {
        width: 200px;
        position: absolute;
        top: 10px;
        right: 0;

        img {
          width: 200px;
        }
      }

      .text {
        position: absolute;
        top: 10px;
        right: 0;
        padding: 8px 23px;

        a {
          color: $color-black;

          &:hover {
            color: $color-gray;
          }
        }
      }
    }
  } // column

  .columns {
    height: 100%;
  }
}

.navbar-menu {
  height: 100%;
  margin: 0px;
  padding: 0px;
  margin-top: 5px;
  pointer-events: auto;
  box-shadow: 0 0 0;

  @media screen and (min-width: $desktop) {
    display: none;
  }

  // abnormal fix on resizing back and forth
  html.modal-open & {

    @media screen and (min-width: $desktop) {
      display: inherit;
    }
  }

  // cursor: pointer;
  // pointer-events: none;
  // @media screen and (min-width: $desktop) {
  // 	pointer-events: auto;
  // }

  & .control-menu {
    cursor: pointer;
    padding: 8px 25px 16px 0px;
    // left: calc(50% - 12px);
    position: absolute;
    top: 70px;
    right: -10px;

    & span {

      &, &:before, &:after {
        height: 2px;
        display: block;
        border-radius: 1px;
        background: $color-white;
        border-bottom: 1px solid $color-black;
        position: absolute;
        // top: 45%;
        // right: 15px;
        width: 25px;
        display: block;
        content: '';
        transition: all 200ms ease-in-out;

        @media screen and (min-width: $desktop) {
          height: 2px;
          width: 30px;
          top: 50%;
        }
      }

      &:before, &:after {
        right: 0px;
        width: 20px;

        @media screen and (min-width: $desktop) {
          width: 25px;
        }
      }

      &:before {
        top: -6px;

        @media screen and (min-width: $desktop) {
          top: -8px;
        }
      }

      &:after {
        top: 6px;

        @media screen and (min-width: $desktop) {
          top: 8px;
        }
      }
    }
  }

  & .active span {
    background-color: transparent;
    border-bottom: 0px;

    &:before, &:after {
      top: 0;
    }

    &:before {
      transform: rotate(45deg);
      border-bottom: 1px solid white;
    }

    &:after {
      transform: rotate(-45deg);
      border-bottom: 1px solid white;
    }
  }
}

</style>



// WEBPACK FOOTER //
// NavBarFull.vue?9cda8e78